import React, { ReactNode, useState } from 'react';

import { classNames } from '@/shared/helpers';
import './style.scss';

type Props = {
  dataLength: number;
  children: ReactNode;
  viewMoreText: string;
  viewLessText: string;
  limitElementsToShow?: number;
};

const ViewMore = (props: Props) => {
  const {
    children,
    viewLessText,
    viewMoreText,
    limitElementsToShow = 3,
    dataLength,
  } = props;
  const [shouldViewAll, setShouldViewAll] = useState(false);

  return (
    <div className="view-more-container">
      <div
        className={classNames(
          'view-more-content',
          shouldViewAll ? 'view-all-content' : ''
        )}
      >
        {children}
      </div>
      {dataLength > limitElementsToShow ? (
        <button onClick={() => setShouldViewAll((state) => !state)}>
          {shouldViewAll ? viewLessText : viewMoreText}
        </button>
      ) : null}
    </div>
  );
};

export default ViewMore;
